import React from 'react';
import { useParams } from 'react-router-dom';
import {
  AppBar,
  AppBarDataCustomItem,
  Button,
  ScrollableViewport,
} from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { useMetricsForm } from 'scenes/metrics/hooks/useMetricsForm';
import { TransparentButton } from 'shared/components/Buttons';
import { NewMetricsForm } from 'scenes/metrics/components/NewMetricsForm';
import { useAppSelector } from 'state/store';
import { HeaderButtonWrapper } from 'shared/components/HeaderButtonWrapper';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { SearchTreeMetrics } from '../components/SearchTreeMetrics';

export const EditMetric: React.FC = (): JSX.Element => {
  const { id } = useParams();
  const metricId = parseInt(id || '', 10);
  const { metricsList } = useAppSelector((state) => state.metricsState);
  const { form, setForm, onUpdate, onCancel } = useMetricsForm({
    initialValues: metricsList[metricId],
  });

  const cancelButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton text="Cancel" onClick={onCancel} />
      </HeaderButtonWrapper>
    ),
  };

  const saveButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button text="Save" onClick={onUpdate} />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <PageContent
      searchTree={<SearchTreeMetrics disableAddButton />}
      headerControls={
        <AppBar menuItems={[cancelButton, saveButton]}>New Metric</AppBar>
      }
    >
      <ScrollableViewport vertical>
        <InnerPagePadding>
          <NewMetricsForm form={form} setForm={setForm} />
        </InnerPagePadding>
      </ScrollableViewport>
    </PageContent>
  );
};
